const CRM_REDUX_CONSTANT = {
  GET_FILTERED_CRMS: 'GET_FILTERED_CRMS',
  GET_CRMS_GRAPH_DATA: 'GET_CRMS_GRAPH_DATA',
};
export default CRM_REDUX_CONSTANT;
